import React from 'react';
import styled from 'styled-components';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { ICON_CLOSE } from '@repo/assets';

type Props = {
  title: string;
  imgSrc?: string;
};

function LocationPrintModal({ title, imgSrc }: Props) {
  const dispatch = useAppDispatch();
  const onClose = () => {
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: { type: 'LOCATION_PRINT', isActive: false, data: null },
    });
  };

  return (
    <BackDrop onClick={onClose}>
      <Container onClick={(e) => e.stopPropagation()}>
        <TitleWrapper>
          <Title>{title || '프린터기 위치 안내'}</Title>
          <button onClick={onClose}>
            <img src={ICON_CLOSE} alt='닫기' width='18px' />
          </button>
        </TitleWrapper>
        <MapImg src={imgSrc} alt='' />
      </Container>
    </BackDrop>
  );
}

export default LocationPrintModal;

const BackDrop = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 375px;
  height: 100%;
  z-index: 500;
  background-color: rgba(0, 0, 0, 0.4);
  @media ${(props) => props.theme.mobile} {
    width: 100%;
  }
`;
const Container = styled.div`
  position: relative;
  top: 20%;
  width: 90%;
  max-height: fit-content;
  padding: 16px;
  border-radius: 10px;
  background-color: #ffffff;
  z-index: 100;
  box-shadow: 0px 0px 20px 0px rgba(174, 191, 204, 0.5);
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

const Title = styled.strong`
  color: #3a3b3e;
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
  word-break: keep-all;
`;

const Time = styled.p`
  color: #80848a;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
`;

const MapImg = styled.img`
  width: 100%;
  margin-top: 36px;
`;
